// @flow

import React from 'react';

import {
  getRetailTableCellObject,
  completeCn,
  completeCnReliance
} from '../../../../services/helpers';
import styles from './incompleteCnDashboard.scss';

export const headers = [
  { label: 'Cnote', key: 'cnote', accessor: 'cnote' },
  { label: 'Client', key: 'clientCode', accessor: 'clientCode' },
  { label: 'Captain', key: 'dp', accessor: 'dp' },
  { label: 'Arrived at', key: 'arrivalTime', accessor: 'arrivalTime' },
  { label: 'WT(kgs)', key: 'weight', accessor: 'weight' },
  { label: 'PKGS', key: 'totalBoxes', accessor: 'totalBoxes' },
  { label: 'Destination', key: 'toBranch', accessor: 'toBranch' }
];

export const relinaceConsignorOrAdminheaders = [
  { label: 'Cnote', key: 'cnote', accessor: 'cnote', maskedCnote: true },
  { label: 'ASN Number', key: 'clientCode', accessor: 'clientAsnNumber' },
  {
    label: 'Vendor Code',
    key: 'clientUserConsignorCode',
    accessor: 'clientUserConsignorCode'
  },
  { label: 'Client', key: 'clientCode', accessor: 'clientCode' },
  { label: 'Captain', key: 'dp', accessor: 'dp' },
  { label: 'Arrived at', key: 'arrivalTime', accessor: 'arrivalTime' },
  { label: 'WT(kgs)', key: 'weight', accessor: 'weight' },
  { label: 'PKGS', key: 'totalBoxes', accessor: 'totalBoxes' },
  { label: 'DC Site Code', key: 'clientCode', accessor: 'clientDcSiteCode' },
  { label: 'Destination', key: 'toBranch', accessor: 'toBranch' }
];

const getConfigColumns = () => {
  const config = headers.map(columnObj => ({
    headerClassName: 'flex-15 zt-custom-th',
    className: 'zt-custom-td flex-15',
    Header: columnObj.label,
    key: columnObj.key,
    accessor: columnObj.key,
    Cell: (row: Object) => (
      <div className="l-row a-center">
        {getRetailTableCellObject(
          row.original && row.original[columnObj.accessor],
          '',
          row.original
        )}
      </div>
    ),
    sortMethod: (a, b) => (a > b ? 1 : -1)
  }));
  config.push({
    Header: 'Action',
    headerClassName: 'flex-15',
    className: 'flex-15',
    Cell: (row: Object) => (
      <div
        className={`${styles.download} action-button-wrapper action-button`}
        onClick={() => completeCn(row)}
      >
        COMPLETE
      </div>
    )
  });
  return config;
};

const getRelianceConfigColumns = () => {
  const config = relinaceConsignorOrAdminheaders.map(columnObj => ({
    headerClassName: 'flex-15 zt-custom-th',
    className: 'zt-custom-td flex-15',
    Header: columnObj.label,
    key: columnObj.key,
    accessor: columnObj.key,
    Cell: (row: Object) => (
      <div className="l-row a-center">
        {columnObj.maskedCnote
          ? 'XXXXXXXXXX'
          : getRetailTableCellObject(
              row.original && row.original[columnObj.accessor],
              '',
              row.original
            )}
      </div>
    ),
    sortMethod: (a, b) => (a > b ? 1 : -1)
  }));
  config.push({
    Header: 'Action',
    headerClassName: 'flex-15',
    className: 'flex-15',
    Cell: (row: Object) => (
      <div
        className={`${styles.download} action-button-wrapper action-button`}
        onClick={() => completeCnReliance(row)}
      >
        Generate LR
      </div>
    )
  });
  return config;
};

export const incompleteCnDashboardConfig = {
  columns: getConfigColumns(),
  className: 'zoomTableLegacyWrapper',
  noDataText: 'Unable to Load Incomplete CNs',
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export const incompleteCnRelianceDashboardConfig = {
  columns: getRelianceConfigColumns(),
  className: 'zoomTableLegacyWrapper',
  noDataText: 'Unable to Load Incomplete CNs',
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export const incompleteCnDashboardTableActionConfig = {};

export const incompleteCnRelianceDashboardTableActionConfig = {};
